import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

let enable_submit

function TextAreaInput({name, valueRequired, maxLength, minLength, visibleRows, maxAllowed})
{
    const [value, setValue] = useState(''),
	  [min, setMin] = useState(minLength),
	  [max, setMax] = useState(maxLength && maxLength > 0 ? maxLength:maxAllowed),
	  [statusMesg, setStatusMesg] = useState(''),
	  updateValue = value => {
	      setValue(value)
	      setStatusMesg('')
	      if ( min > 0 && value.length < min ) {
		  setStatusMesg(`string too short ... must be at least ${min} characters`)
		  enable_submit(false)
		  return
	      }
	      if ( max > 0 && value.length > max ) {
		  setStatusMesg(`string too long ... must be less than ${max} characters`)
		  enable_submit(false)
		  return
	      }
	      if ( valueRequired && value.length === 0 ) {
		  setStatusMesg('value is required')
		  enable_submit(false)
		  return
	      }
	      enable_submit(true)
	  }
    useEffect(() => {
	enable_submit(!valueRequired)
    }, [valueRequired])
    return (
	<div className="mb-2">
	    <div className="d-flex justify-content-center">
		<textarea className="form-control tertiary-text"
			  autoFocus
			  name={name}
			  maxLength={max}
			  minLength={min}
			  rows={visibleRows}
			  value={value}
			  onChange={ev => updateValue(ev.target.value)}/>
	    </div>
	    <div className="form-text">{statusMesg}</div>
	</div>
    )
}

(function() {
    const rootId = document.currentScript.getAttribute('data-rootid'),
	  el = document.getElementById(rootId),
	  stepId = el.getAttribute('data-stepid')
    let minLength = el.getAttribute('data-minLength'),
	maxLength = el.getAttribute('data-maxLength'),
	visibleRows = el.getAttribute('data-visibleRows'),
	valueRequired = el.getAttribute('data-required') === 'True'
    minLength = minLength === 'None' ? null : +minLength
    maxLength = maxLength === 'None' ? null : +maxLength
    visibleRows = visibleRows === 'None' ? null : +visibleRows
    enable_submit = (enable) => {
	if ( 'enable_submit' in window ) window.enable_submit(stepId, enable)
    }
    createRoot(el).render(<TextAreaInput name={el.getAttribute('data-name')}
					 valueRequired={valueRequired}
					 maxLength={maxLength}
					 minLength={minLength}
					 visibleRows={visibleRows}
					 maxAllowed={el.getAttribute('data-maxAllowed')}
					 element={el}/>);
})();
